import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HostPortalClient, MyShipmentsDTO, ShippingOption, User, WebinarClient, WebinarRoomOwnerDTO, WebinarShipment, USPSAddress } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { openConfirmDialog } from 'src/app/confirm-dialog/confirm-dialog.component';
import { FromAddressDialogComponent } from './from-address-dialog.component';
import { TrackingDialogComponent } from './tracking-dialog.component';

export interface ShipmentDateGroup {
  dateKey: string;
  dateLabel: string;
  year: number;
  month: string;
  day: number;
  items: WebinarShipment[];
}

@Component({
    selector: 'app-my-shipments',
    templateUrl: './my-shipments.component.html',
    styleUrls: ['./my-shipments.component.css'],
    standalone: false
})
export class MyShipmentsComponent implements OnInit {
  loggedUser: User;
  webinarRooms: WebinarRoomOwnerDTO[] = [];
  roomId: number;
  NonShippedWebinars: WebinarShipment[] = [];
  ShippedWebinars: WebinarShipment[] = [];
  ShippingOptions: ShippingOption[] = [];
  uspsShippingOption: ShippingOption | null = null;
  myShipmentDTO: MyShipmentsDTO;
  currentRoomId: number;
  webinarRoomControl = new UntypedFormControl('');
  searchQuery: string = '';
  NonShippedWebinarsFiltered: WebinarShipment[] = [];
  ShippedWebinarsFiltered: WebinarShipment[] = [];
  pendingDateGroups: ShipmentDateGroup[] = [];
  shippedDateGroups: ShipmentDateGroup[] = [];
  activeTabIndex = 0;
  isMobileView = false;
  subscription: Subscription;
  expandedShipmentContext: {
    year: number;
    month: string;
    day: number;
    shipmentId: number;
    dateKey: string;
  } | null = null;
  expandedPanelIds = new Set<string>();

  private readonly monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  constructor(
    private hostPortalClient: HostPortalClient,
    private commonServices: CommonServices,
    private webinarClient: WebinarClient,
    private customServices: CustomServiceService,
    private dialog: MatDialog,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetRooms();
    this.GetShippingOptions();
    this.NonShippedWebinarsFiltered = [...this.NonShippedWebinars];
    this.ShippedWebinarsFiltered = [...this.ShippedWebinars];
  }

  GetShippingOptions() {
    this.hostPortalClient.getShippingOptions().subscribe(x => {
      this.ShippingOptions = x || [];
      this.uspsShippingOption = this.ShippingOptions.find(option =>
        (option.name || '').toLowerCase().includes('usps')
      ) || null;
    });
  }

  applyUspsShippingOption(shipment: WebinarShipment): void {
    if (!this.uspsShippingOption || !shipment) {
      return;
    }

    shipment.shippingOptionId = this.uspsShippingOption.id;
    shipment.shippingOption = this.uspsShippingOption;
  }

  NotifyUser(trackingId, webinarShipmentId) {
    if (!trackingId) {
      this.commonServices.showMessage("Error", "Please enter a tracking number and carrier before notifying the winner");
      return false;
    }
    if (!this.getCarrierName(this.findShipment(webinarShipmentId))) {
      this.commonServices.showMessage("Error", "Please select a carrier before notifying the winner");
      return false;
    }
    openConfirmDialog(this.dialog, {
        message: `Are you sure, you want to notify (After Notify - Webinar will move to notified webinars in the same page) ?`,
        buttonText: {
          ok: 'Yes, Notify',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      console.log(res)
      if (res === true) {
        this.hostPortalClient.notifyUser(webinarShipmentId).subscribe({
          next: (x) => {
            if (!x) {
              this.commonServices.showMessage("Error", "Could not notify the winner. Please confirm carrier and tracking are saved.");
              return;
            }
            this.commonServices.showMessage("Success", "Notified successfully");
            this.GetMyShipments(this.roomId);
          },
          error: () => {
            this.commonServices.showMessage("Error", "Could not notify the winner.");
          }
        });
      }
    })
  }

  GetRooms() {
    this.webinarClient.getWebinarRoomsByUser(this.loggedUser.id)
      .subscribe(data => {
        this.webinarRooms = data;
        if (data.length > 0) {
          this.webinarRoomControl.setValue(data[0].webinarRoomId);
        }
        this.GetMyShipments(this.webinarRooms[0].webinarRoomId);
      });
  }

  GetStatsOfRoom(e) {
    this.GetMyShipments(e.value);
  }

  GetMyShipments(roomId, restoreExpansion = false) {
    this.roomId = roomId;
    this.hostPortalClient.getMyShipments(roomId)
      .subscribe(x => {
        this.currentRoomId = roomId;
        this.NonShippedWebinars = x.nonShippedWebinars;
        this.ShippedWebinars = x.shippedWebinars;
        this.NonShippedWebinarsFiltered = [...this.NonShippedWebinars];
        this.ShippedWebinarsFiltered = [...this.ShippedWebinars];
        this.filterWebinars();
        if (restoreExpansion) {
          setTimeout(() => this.restoreAccordionExpansion(), 0);
        }
      });
  }

  GetAveraging() {
    if (this.NonShippedWebinarsFiltered.length == 0) {
      return 0;
    }
    var totalDays = 0;
    this.NonShippedWebinarsFiltered.forEach(x => {
      totalDays = totalDays + x.daysPassed;
    });
    return Math.floor(totalDays / this.NonShippedWebinarsFiltered.length);
  }

  isShowNotifyButton(row: WebinarShipment) {
    return !!this.getDisplayTracking(row) && !!this.getCarrierName(row);
  }

  hasUspsLabel(row: WebinarShipment): boolean {
    return !!(row.uspsLabelUrl || row.uspsTrackingNumber);
  }

  isUspsCarrier(row: WebinarShipment | undefined): boolean {
    const name = (row?.shippingOption?.name || '').toLowerCase();
    return name.includes('usps');
  }

  isUspsLabelActive(row: WebinarShipment): boolean {
    return this.hasUspsLabel(row) && (!row.shippingOption || this.isUspsCarrier(row));
  }

  showShippingDetails(row: WebinarShipment): boolean {
    return this.hasUspsLabel(row) || !!(this.getDisplayTracking(row) || this.getCarrierName(row));
  }

  getDisplayTracking(row: WebinarShipment): string {
    return row?.trackingId || row?.uspsTrackingNumber || '';
  }

  getCarrierName(row: WebinarShipment | undefined): string {
    if (!row) {
      return '';
    }
    if (row.shippingOption?.name) {
      return row.shippingOption.name;
    }
    if (this.hasUspsLabel(row)) {
      return this.uspsShippingOption?.name || 'USPS';
    }
    return '';
  }

  carrierKind(row: WebinarShipment | undefined): 'usps' | 'ups' | 'fedex' | 'dhl' | 'other' {
    const name = (this.getCarrierName(row) || '').toLowerCase().replace(/\./g, '');
    if (name.includes('usps') || (!name && row && this.hasUspsLabel(row))) {
      return 'usps';
    }
    if (name.includes('fedex') || name.includes('fed ex')) {
      return 'fedex';
    }
    if (name.includes('dhl')) {
      return 'dhl';
    }
    if (/\bups\b/.test(name) || name.startsWith('ups') || name.includes('united parcel')) {
      return 'ups';
    }
    if (row && this.hasUspsLabel(row) && !name) {
      return 'usps';
    }
    return 'other';
  }

  carrierLabel(row: WebinarShipment | undefined): string {
    const name = this.getCarrierName(row);
    if (name) {
      return name;
    }
    const kind = this.carrierKind(row);
    if (kind === 'usps') {
      return 'USPS';
    }
    if (kind === 'ups') {
      return 'UPS';
    }
    if (kind === 'fedex') {
      return 'FedEx';
    }
    if (kind === 'dhl') {
      return 'DHL';
    }
    return 'Carrier';
  }

  hasManualTracking(row: WebinarShipment): boolean {
    return !!this.getDisplayTracking(row) && !this.isUspsLabelActive(row);
  }

  findShipment(shipmentId: number): WebinarShipment | undefined {
    return [...this.NonShippedWebinars, ...this.ShippedWebinars].find(x => x.id === shipmentId);
  }

  getDisplayShippingPrice(row: WebinarShipment): number | undefined {
    if (this.isUspsLabelActive(row)) {
      return row.uspsPostageAmount ?? row.shippingPrice;
    }
    return row.shippingPrice ?? undefined;
  }

  getDaysUrgencyClass(daysPassed: number): string {
    if (daysPassed >= 14) {
      return 'urgent';
    }
    if (daysPassed >= 7) {
      return 'warning';
    }
    return 'normal';
  }

  formatAddress(row: WebinarShipment): string {
    const address = row.shipmentAddress;
    if (!address) {
      return '';
    }

    const state = address.state?.name || '';
    const phone = address.phone ? ` · ${address.phone}` : '';
    return `${address.street}, ${address.city} ${state} ${address.zipCode}${phone}`;
  }

  getDatePanelId(dateKey: string, isShipped = false): string {
    return `${isShipped ? 'shipped' : 'pending'}-date-${dateKey}`;
  }

  private getStateCode(state: { stateCode?: string; name?: string } | undefined): string {
    return (state?.stateCode || '').trim().toUpperCase();
  }

  private buildDateGroups(
    shipments: WebinarShipment[],
    sortOrder: 'asc' | 'desc' = 'asc'
  ): ShipmentDateGroup[] {
    const grouped = shipments.reduce((acc, webinar) => {
      const date = new Date(webinar.webinarEndDate);
      const year = date.getFullYear();
      const month = date.toLocaleString('default', { month: 'long' });
      const day = date.getDate();
      const dateKey = `${year}-${month}-${day}`;

      if (!acc[dateKey]) {
        acc[dateKey] = {
          dateKey,
          dateLabel: date.toLocaleDateString('default', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }),
          year,
          month,
          day,
          items: []
        };
      }

      acc[dateKey].items.push(webinar);
      return acc;
    }, {} as Record<string, ShipmentDateGroup>);

    const groups = Object.values(grouped);
    groups.forEach(group => {
      group.items.sort((a, b) => b.daysPassed - a.daysPassed);
    });

    return groups.sort((a, b) => {
      const dateA = new Date(a.year, this.monthNames.indexOf(a.month), a.day).getTime();
      const dateB = new Date(b.year, this.monthNames.indexOf(b.month), b.day).getTime();
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });
  }

  filterWebinars() {
    const query = this.searchQuery.toLowerCase().trim();

    const matches = (webinar: WebinarShipment) => {
      if (!query) {
        return true;
      }

      return webinar.webinar.toLowerCase().includes(query)
        || (webinar.newOwner || '').toLowerCase().includes(query)
        || (webinar.newOwnerEmail || '').toLowerCase().includes(query);
    };

    this.NonShippedWebinarsFiltered = this.NonShippedWebinars.filter(matches);
    this.ShippedWebinarsFiltered = this.ShippedWebinars.filter(matches);
    this.pendingDateGroups = this.buildDateGroups(this.NonShippedWebinarsFiltered, 'asc');
    this.shippedDateGroups = this.buildDateGroups(this.ShippedWebinarsFiltered, 'desc');
  }

  OpenUSPSLabelDialog(shippingId: number) {
    const shipment = this.NonShippedWebinars.find(x => x.id === shippingId);
    
    if (!shipment) {
      this.commonServices.showMessage("error", "Shipment not found", 5);
      return;
    }

    if (!shipment.shipmentAddress) {
      this.commonServices.showMessage("error", "Destination address not found for this shipment", 5);
      return;
    }

    const destinationValidationMessage = this.getDestinationAddressValidationMessage(shipment);
    if (destinationValidationMessage) {
      this.commonServices.showMessage("error", destinationValidationMessage, 5);
      return;
    }

    const existingFromAddress = shipment.fromAddressName ? USPSAddress.fromJS({
      name: shipment.fromAddressName,
      street: shipment.fromAddressStreet,
      city: shipment.fromAddressCity,
      state: shipment.fromAddressState,
      zipCode: shipment.fromAddressZipCode,
      phone: shipment.fromAddressPhone || ""
    }) : null;

    this.expandedShipmentContext = this.getShipmentAccordionContext(shipment);
    this.setExpandedPanelsFromContext(this.expandedShipmentContext);

    const dialogRef = this.dialog.open(FromAddressDialogComponent, {
      width: '700px',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      autoFocus: false,
      panelClass: 'usps-label-dialog',
      data: { 
        fromAddress: existingFromAddress,
        shipment: shipment,
        webinarRoomId: this.currentRoomId
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result?.success) {
        return;
      }

      const shipment = this.NonShippedWebinars.find(x => x.id === result.shipmentId);
      if (shipment) {
        this.applyLabelResponseToShipment(shipment, result.response, result.labelDetails);
      } else {
        this.GetMyShipments(this.currentRoomId, true);
      }

      const trackingNumber = this.getResponseTrackingNumber(result.response);
      this.commonServices.showMessage(
        'Success',
        trackingNumber
          ? `USPS label created successfully! Tracking: ${trackingNumber}`
          : 'USPS label created successfully!'
      );

      this.scrollToShipment(result.shipmentId);
    });
  }

  OpenTrackingDialog(shippingId: number) {
    const shipment = this.findShipment(shippingId);
    if (!shipment) {
      this.commonServices.showMessage("error", "Shipment not found", 5);
      return;
    }

    if (!this.ShippingOptions.length) {
      this.commonServices.showMessage("error", "No shipping carriers are available", 5);
      return;
    }

    if (!shipment.isNotified) {
      this.expandedShipmentContext = this.getShipmentAccordionContext(shipment);
      this.setExpandedPanelsFromContext(this.expandedShipmentContext);
    }

    const dialogRef = this.dialog.open(TrackingDialogComponent, {
      width: '560px',
      maxWidth: '90vw',
      data: {
        shipment,
        shippingOptions: this.ShippingOptions
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result?.success) {
        return;
      }

      const updated = this.findShipment(result.shipmentId);
      if (updated) {
        this.applyTrackingResultToShipment(updated, result);
      } else {
        this.GetMyShipments(this.currentRoomId, true);
      }

      this.commonServices.showMessage(
        'Success',
        `Tracking saved for ${result.shippingOption?.name || 'carrier'}: ${result.trackingId}`
      );
      this.scrollToShipment(result.shipmentId);
    });
  }

  private applyTrackingResultToShipment(shipment: WebinarShipment, result: {
    shippingOptionId?: number;
    shippingOption?: ShippingOption;
    trackingId?: string;
    shippedOn?: Date;
    shippingPrice?: number | null;
  }): void {
    shipment.shippingOptionId = result.shippingOptionId;
    shipment.shippingOption = result.shippingOption;
    shipment.trackingId = result.trackingId;
    if (result.shippedOn) {
      shipment.shippedOn = result.shippedOn;
    }
    if (result.shippingPrice != null) {
      shipment.shippingPrice = result.shippingPrice;
    }
  }

  private getResponseTrackingNumber(response: any): string | undefined {
    return response?.trackingNumber ?? response?.TrackingNumber;
  }

  private applyLabelResponseToShipment(
    shipment: WebinarShipment,
    response: any,
    labelDetails?: {
      serviceType?: string;
      labelFormat?: string;
      packageWeight?: number;
      packageLength?: number;
      packageWidth?: number;
      packageHeight?: number;
      fromAddress?: USPSAddress;
    }
  ): void {
    if (!response) {
      return;
    }

    const trackingNumber = this.getResponseTrackingNumber(response);
    const labelUrl = response.labelUrl ?? response.LabelUrl;
    const postageAmount = response.postageAmount ?? response.PostageAmount;
    const labelFormat = response.labelFormat ?? response.LabelFormat ?? labelDetails?.labelFormat;

    if (trackingNumber) {
      shipment.uspsTrackingNumber = trackingNumber;
      shipment.trackingId = trackingNumber;
    }
    if (labelUrl) {
      shipment.uspsLabelUrl = labelUrl;
    }
    if (postageAmount != null) {
      shipment.uspsPostageAmount = postageAmount;
      shipment.shippingPrice = postageAmount;
    }
    if (labelFormat) {
      shipment.uspsLabelFormat = labelFormat;
      shipment.labelFormat = labelFormat;
    }
    if (labelDetails?.serviceType) {
      shipment.uspsServiceType = labelDetails.serviceType;
    }
    if (labelDetails?.packageWeight != null) {
      shipment.packageWeight = labelDetails.packageWeight;
    }
    if (labelDetails?.packageLength != null) {
      shipment.packageLength = labelDetails.packageLength;
    }
    if (labelDetails?.packageWidth != null) {
      shipment.packageWidth = labelDetails.packageWidth;
    }
    if (labelDetails?.packageHeight != null) {
      shipment.packageHeight = labelDetails.packageHeight;
    }

    const fromAddress = labelDetails?.fromAddress;
    if (fromAddress) {
      shipment.fromAddressName = fromAddress.name;
      shipment.fromAddressStreet = fromAddress.street;
      shipment.fromAddressCity = fromAddress.city;
      shipment.fromAddressState = fromAddress.state;
      shipment.fromAddressZipCode = fromAddress.zipCode;
      shipment.fromAddressPhone = fromAddress.phone;
    }

    if (!shipment.shippedOn) {
      shipment.shippedOn = new Date();
    }

    this.applyUspsShippingOption(shipment);
  }

  private scrollToShipment(shipmentId: number): void {
    setTimeout(() => {
      document.getElementById(`shipment-${shipmentId}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 150);
  }

  private getShipmentAccordionContext(shipment: WebinarShipment) {
    const date = new Date(shipment.webinarEndDate);
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' });
    const day = date.getDate();

    return {
      year,
      month,
      day,
      shipmentId: shipment.id,
      dateKey: `${year}-${month}-${day}`
    };
  }

  private setExpandedPanelsFromContext(ctx: {
    dateKey: string;
  } | null): void {
    this.expandedPanelIds.clear();
    if (!ctx?.dateKey) {
      return;
    }

    this.activeTabIndex = 0;
    this.expandedPanelIds.add(this.getDatePanelId(ctx.dateKey, false));
  }

  isPanelExpanded(panelId: string): boolean {
    return this.expandedPanelIds.has(panelId);
  }

  onPanelOpened(panelId: string): void {
    this.expandedPanelIds.add(panelId);
  }

  onPanelClosed(panelId: string): void {
    this.expandedPanelIds.delete(panelId);
  }

  private restoreAccordionExpansion(): void {
    const ctx = this.expandedShipmentContext;
    if (!ctx) {
      return;
    }

    this.setExpandedPanelsFromContext(ctx);

    setTimeout(() => {
      this.scrollToShipment(ctx.shipmentId);
      this.expandedShipmentContext = null;
    }, 100);
  }

  getDestinationAddressValidationMessage(shipment: WebinarShipment): string | null {
    const address = shipment?.shipmentAddress;
    if (!address) {
      return 'Destination address not found for this shipment';
    }

    const recipientName = (address.name || shipment.newOwner || '').trim();
    if (!recipientName) {
      return 'Recipient name is missing on the shipping address';
    }
    if (recipientName.split(/\s+/).filter(Boolean).length < 2) {
      return 'Recipient name must include first and last name';
    }
    if (!address.street?.trim()) {
      return 'Recipient street address is missing';
    }
    if (!address.city?.trim()) {
      return 'Recipient city is missing';
    }
    if (!this.getStateCode(address.state)) {
      return 'Recipient state is missing or invalid. Please ensure the state has a valid 2-letter code in StateList.';
    }
    if (!address.zipCode || !/^\d{5}(\d{4})?$/.test(String(address.zipCode).trim())) {
      return 'Recipient ZIP code is missing or invalid';
    }

    return null;
  }

  isDestinationAddressValid(shipment: WebinarShipment): boolean {
    return this.getDestinationAddressValidationMessage(shipment) === null;
  }

  downloadLabel(row: WebinarShipment) {
    if (!row || !row.uspsLabelUrl) {
      this.commonServices.showMessage("error", "No label is available to download for this shipment.", 5);
      return;
    }

    const url = row.uspsLabelUrl;
    const fileName = `USPS-Label-${row.uspsTrackingNumber || row.trackingId || row.id}.pdf`;

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;

    if (!url.startsWith('data:')) {
      anchor.target = '_blank';
      anchor.rel = 'noopener';
    }

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}
